import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AlertService } from '../../../_shared/services/alert.service';
import { UtilService } from '../../../_shared/services/util.service';

import { Zone } from '../../shared/zone.model';
import { ZoneService } from '../../shared/zone.service';

@Component({
  selector: 'app-zone-translation-modal',
  templateUrl: './zone-translation-modal.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class ZoneTranslationModalComponent {
  zone: Zone = null;
  zoneCopy = null;

  modalTitle = this.data.title;
  zoneId = this.data.obj.id;
  language = this.data.params.language;

  form: FormGroup;

  serverErrors = [];
  sendingForm = false;

  constructor(
    private alertService: AlertService,
    private utilService: UtilService,
    private zoneService: ZoneService,
    private formBuilder: FormBuilder,
    private ref: MatDialogRef<ZoneTranslationModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getZone();
  }

  // Referenced from app-item-detail-form-actions
  onSavedZoneTranslation() {
    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    const fields = ['name', 'description'];

    // console.log(formData);
    // console.log(this.zoneCopy);
    // return;

    if (!fields.some((field) => formData[field] !== this.zoneCopy[field])) {
      this.close();
      return;
    }

    this.sendingForm = true;

    this.zoneService.saveZone(this.zone.id, formData, this.language.lang).subscribe({
      next: (response) => {
        this.alertService.open('TRANSLATION_SAVED');

        this.sendingForm = false;

        this.ref.close(response);
      },
      error: (response) => {
        this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

        this.sendingForm = false;
      },
    });
  }

  onCanceled() {
    this.close();
  }

  close() {
    this.ref.close();
  }

  private getZone() {
    let params = {
      get: 'translate',
      lang: this.language.lang,
    };

    this.zoneService.getZone(this.zoneId, params).subscribe((zone) => {
      this.zone = zone;
      this.zoneCopy = { ...this.zone };

      this.setZoneTranslationForm();

      this.form.patchValue(this.zone);
    });
  }

  private setZoneTranslationForm() {
    this.form = this.formBuilder.group({
      name: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: '',
    });
  }
}

/*

const formData = this.utilService.deleteNullFields(fields, this.form.value);

this.form = this.formBuilder.group({
      name: [
        this.zone.name,
        {
          validators: [
            Validators.required,
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: [this.zone.description],
    });
  }

*/
